import {Observable} from 'rxjs';
import {scan} from 'rxjs/operators';

export interface LastTwoValues<T> {
  previous?: T;
  current?: T;
}

export const lastTwoValues = () => <T>(source: Observable<T>): Observable<LastTwoValues<T>> => source.pipe(
  scan((acc, val) => {
      // Save the previous value and return an object containing both the
      // current and previous values
      return { previous: acc.current, current: val };
  }, { previous: undefined, current: undefined } as LastTwoValues<T>)
);
